const About = () => {
  return (
    <section id="about">
      <h1>Why This App Exists . . .</h1>
      <p>
        I made Studious Guide because I was lazy to solve repetitive questions
        manually XD, and also because I wanted to get started with Web
        Development. If you are a student like me, you might be frustrated with
        the same basic questions appearing everywhere in your textbooks and
        practice worksheets a hundred times with just different values. And
        using your brain to solve all of them does not help in any way with your
        education (at least that's what I think) so why not program a computer
        to do so? That's what they are meant for, right? That sums up my
        philosophy behind making the app.
      </p>
      <p>
        And yes, another reason I made the app was to start making apps in the
        first place. I am a beginner in web development and this is my first
        ReactJS project. Check out this project's repository on{" "}
        <a href="https://github.com/git-kush/studious-guide-2">GitHub.</a>
      </p>
      <p>
        If you have any issues/questions regarding Studious Guide, you can
        contact me via <a href="mailto:kush@kush.in">email.</a> The app is
        licensed under the{" "}
        <a href="https://www.apache.org/licenses/LICENSE-2.0.txt">Apache 2.0</a>{" "}
        license and is subject to copyright.
      </p>
    </section>
  );
};

export default About;
